// @flow

import React, { useEffect } from 'react';
import { isBrowser } from 'react-device-detect';

import Job from 'components/Job';
import JobThirdParty from 'components/JobThirdParty';
import JobMobile from 'components/JobMobile';
import JobThirdPartyMobile from 'components/JobThirdPartyMobile';
import Banner from 'components/Banner';

import Inquiry from './Inquiry';
import { Banners } from '../../../../packs/components/Banners';

type Props = {
  jobs: any,
  user: any,
  isCurrentUser: boolean,
  showInput: boolean,
  handleLike: Function,
  toggleVisibility: Function
};

export default ({ jobs, user, isCurrentUser, handleLike, toggleVisibility, showInput }: Props) => {
  useEffect(() => {
    Banners(jobs);
  }, [jobs]);

  const renderJobItems = () => (
    jobs.map(({ id, type, ...rest }, index) => {
      if (type === 'third_party_jobs') {
        return (
          <React.Fragment key={`thirdPartyJob_${id}`}>
            { index === 4 && <div className='mt-4 mb-4'><Banner slug="job-search-inner" classes="mt-3 mb-3" viewEvent="view_inner_banner_on_jobs" clickEvent="click_on_inner_banner_on_jobs"/></div> }
            <JobThirdParty
              job={{ id, ...rest }}
              trackEventName='view_search_job'
              trackClickName='click_on_search_job'/>
          </React.Fragment>
        );
      }

      return(
        <React.Fragment key={id}>
          { index === 4 && <div className='mt-4 mb-4'><Banner slug="job-search-inner" classes="mt-3 mb-3" viewEvent="view_inner_banner_on_jobs" clickEvent="click_on_inner_banner_on_jobs"/></div> }
          <Job
            index={index}
            job={{ id, ...rest }}
            user={user}
            isCurrentUser={isCurrentUser}
            handleLike={handleLike}
            trackEventName='view_search_job'
            trackClickName='click_on_search_job'/>
        </React.Fragment>
      );
    })
  );

  const renderJobItemsMobile = () => (
    jobs.map(({ id, type, ...rest }, index) => {
      if (type === 'third_party_jobs') {
        return <JobThirdPartyMobile
          key={`thirdPartyJob_${id}`}
          job={{ id, ...rest }}
          trackEventName='view_search_job'
          trackClickName='click_on_search_job'
        />;
      }

      return <JobMobile
        key={id}
        index={index}
        job={{ id, ...rest }}
        trackEventName='view_search_job'
        trackClickName='click_on_search_job'
      />;
    })
  );

  return (
    <>
      {
        jobs && <div className="jobs-items">
          { isBrowser ? renderJobItems() : renderJobItemsMobile() }
          <Inquiry isCurrentUser={isCurrentUser} toggleVisibility={toggleVisibility} showInput={showInput}/>
        </div>
      }
    </>
  );
};
